/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { Component, Input, TemplateRef } from "@angular/core";
import { MatExpansionModule } from "@angular/material/expansion";
import { NgxTippyModule } from "ngx-tippy-wrapper";

@Component({
	selector: "globalictcc-accordion",
	standalone: true,
	imports: [MatExpansionModule, NgxTippyModule],
	templateUrl: "./accordion.component.html",
	styleUrl: "./accordion.component.scss"
})
export class AccordionComponent {
	@Input() public title: string = "";
	@Input() public tooltip: string | TemplateRef<unknown> = "";
	@Input() public isExpanded: boolean = false;
}
